'use strict'

export const afbeeldingSlider = (() => {
    const init = () => {
        const sliders = document.querySelectorAll('.afbeeldingSlider')

        if (sliders.length) {
            sliders.forEach(slider => {
                const track = slider.querySelector('.afbeeldingSlider-track')
                const containers = slider.querySelectorAll('.afbeeldingSlider-container')
                const selectors = slider.querySelectorAll('.afbeeldingSlider-selector')

                let currentIndex = 0

                // Calculate and center the selected image
                const updateSlidePosition = () => {
                    const containerWidth = containers[currentIndex].offsetWidth
                    const trackWidth = track.scrollWidth
                    const sliderWidth = slider.offsetWidth

                    const offset = containers[currentIndex].offsetLeft - (sliderWidth / 2 - containerWidth / 2)
                    track.style.transform = `translateX(-${Math.min(Math.max(offset, 0), trackWidth - sliderWidth)}px)`

                    selectors.forEach(selector => selector.classList.remove('bg-primary'))
                    selectors[currentIndex].classList.add('bg-primary')
                };

                // Handle bullet clicks
                selectors.forEach((selector, index) => {
                    selector.addEventListener('click', () => {
                        currentIndex = index
                        updateSlidePosition()
                    })
                })

                // Center the first image initially
                updateSlidePosition()

                window.addEventListener('resize', updateSlidePosition)
            })
        }
    }

    return { init }
})()